import { InjectionToken } from '@angular/core';

export const ZEF_GITLAB_FEATURE_NAME = '@zerops/zef/gitlab';
export const ZEF_GITLAB_AUTH_PROGRESS_KEY = `${ZEF_GITLAB_FEATURE_NAME}/auth-request`;
export const ZEF_GITLAB_CALLBACK_URL = new InjectionToken<string>('zef-gitlab-callback-url');
export const ZEF_GITLAB_API_URL = new InjectionToken<string>('zef-gitlab-api-url');
